




import { defineComponent, useMeta } from '@nuxtjs/composition-api'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'

export default defineComponent({
  name: 'PagesProductListerActie',

  setup() {
    const {
      breadcrumbsSchemaScript,
      setBreadcrumbsSchemaScript,
    } = useBreadcrumbsSchemaScript()

    const title = 'Actie'

    setBreadcrumbsSchemaScript([
      {
        label: title,
      },
    ])

    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })

    return {
      title,
    }
  },

  head: {},
})
